import React, {useEffect, useRef, useState} from 'react';
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import {useNavigate} from "react-router-dom";
import {buildUrl, PLATFORM_DASHBOARD} from "../../../services/PageUtils";
import {useApiRequest} from "../../../hooks/useApiRequest";
import {UserService} from "../../../services/api/UserService";
import ErrorBox from "../../onboarding/components/ErrorBox";
import Button from "../../../components/Button";
import {useAppDispatch} from "../../../services/store/store";
import {loadUser} from "../../../services/store/reducers/session/asyncActions";
import Container from "../../../components/Container";
import GoBackArrow from "../../../components/GoBackArrow";
import Avatar from "../../../components/Avatar";

interface Props {

}

const EditProfile = ({}: Props) => {

    const { user } = handicaddieSelector((state) => state.session)
    const dispatch = useAppDispatch()

    const nav = useNavigate();

    const [newAvatar, setNewAvatar] = useState();
    const [firstName, setFirstName] = useState<string>();
    const [lastName, setLastName] = useState<string>();
    const profileImageFileFinder = useRef<HTMLInputElement | null>(null);

    const { updateUser, uploadAvatar } = UserService();

    const { execute: callUpdateUser, loading, errMsg, setErrMsg } = useApiRequest(updateUser);
    const { execute: callUploadAvatar, loading: avatarLoading, errMsg: avatarErrMsg } = useApiRequest(uploadAvatar);

    useEffect(() => {
        load()
    }, []);

    useEffect(() => {
        load()
    }, [user]);

    const load = () => {
        if (!user) {
            nav(buildUrl(PLATFORM_DASHBOARD));
            return;
        }

        setFirstName(user.firstName);
        setLastName(user.lastName);
    }

    const updateProfile = async () => {
        if (!user) {
            setErrMsg("User not found. Refresh the page and try again.");
            return;
        }

        if (!firstName || !lastName) {
            setErrMsg("First and last name are required.");
            return;
        }

        const resp = await callUpdateUser(user.id, {
            ...user,
            firstName: firstName,
            lastName: lastName,
        });

        if (!resp || resp.error) {
            console.log('no user response...')
            return;
        }

        if (newAvatar) {
            console.log('uploading avatar...')
            console.log(
                'newAvatar',
                newAvatar)
            await callUploadAvatar(user.id, newAvatar);
            if (avatarErrMsg) {
                setErrMsg(avatarErrMsg);
                return;
            }
        }

        dispatch(loadUser())
        nav(buildUrl(PLATFORM_DASHBOARD));
    }

    return (
        <Container>
            <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                <div className={"header_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <div>
                    <GoBackArrow />
                    <span className={"heading"}>Edit Profile</span>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '16px'}}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '16px', justifyContent: 'center' }}>
                        <div style={{ padding: '16px'}} onClick={() => profileImageFileFinder.current?.click()}>
                            <Avatar
                                url={newAvatar ? URL.createObjectURL(newAvatar) : undefined}
                                user={'current'}
                                size={'md'}
                                showEditWatermark
                                style={{
                                    maxWidth: '300px',
                                    margin: '0 auto'
                                }}
                            />
                        </div>

                        <input
                            type="file"
                            name="avatar"
                            placeholder="Avatar"
                            ref={profileImageFileFinder}
                            style={{ display: 'none' }}
                            onChange={(event: any) => {
                                setNewAvatar(event.currentTarget.files[0]);
                            }}
                        />
                    </div>

                    <div>
                        <span>First Name</span>
                        <input
                            className="onboarding_input"
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                        />
                    </div>

                    <div>
                        <span>Last Name</span>
                        <input
                            className="onboarding_input"
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                        />
                    </div>

                    <ErrorBox text={errMsg} />
                    <Button text={"SAVE"} disabled={loading || avatarLoading} onClick={updateProfile} />
                </div>
            </div>
        </Container>
    )
}

export default EditProfile;